import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import questionReducer from './questions/questionSlice';
import voucherReducer from './vouchers/voucherSlice';
import answerReducer from './answers/answerSlice';
import settingReducer from './settingSlice';
import learningReducer from './learning/learningSlice';
import userReducer from './user/userSlice';
import notificationReducer from './notification/notificationSlice';
import summaryReducer from './summary/summarySlice';
import triviaReducer from './trivia/triviaSlice';
import btdReducer from './bloodtypedestiny/btdSlice';
import lifehackReducer from './lifehack/lifehackSlice';
import onThisDayReducer from './onthisday/onThisDaySlice';
import paintingReducer from './painting/paintingSlice';
import { useDispatch } from 'react-redux';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    question: questionReducer,
    voucher: voucherReducer,
    answer: answerReducer,
    setting: settingReducer,
    learning: learningReducer,
    user: userReducer,
    notification: notificationReducer,
    summary: summaryReducer,
    trivia: triviaReducer,
    btd: btdReducer,
    lifehack: lifehackReducer,
    onthisday: onThisDayReducer,
    painting: paintingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
